import React from 'react'
import { DatePicker } from 'antd'
import moment from 'moment'

export default function BridgeDateRange({ value, onChange, maxRange }) {
  const disabledDate = (current) => {
    if (!value || value.length !== 2 || !value[0]) return false
    const diff = current.diff(value[0], 'days')
    return diff + 1 > maxRange || diff < 0
  }
  return (
    <DatePicker.RangePicker
      value={value}
      disabledDate={maxRange ? disabledDate : undefined}
      onChange={onChange}
      format="YYYY-MM-DD"
      allowClear={false}
    />
  )
}

export const formatDate = (date) =>
  date ? moment(date).format('YYYY-MM-DD') : null

export const formatDateTime = (value) =>
  value ? moment(value).format('YYYY-MM-DD HH:mm') : '—'
